

import { Injectable } from '@angular/core';
import { RestApi } from './rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class WSFederationClient {
  private profile: any;

  constructor(private _api: RestApi) { }

  login(): Observable<any> {
    return this._api.get('api/auth/wsfederation/IsAuthenticated')
      .map(res => {
        res = res || {};
        const data = {
          name: res.Name || '',
          status: res.Status || ''
        };
        this.profile = data;
        return data.status || false;
      })
      .catch((err) => Observable.throw(err._body));
  };

  submitLogin() {
    const wsfFormLogin: HTMLFormElement = document.getElementById('wsfLogin') as HTMLFormElement;
    wsfFormLogin.submit();
  }
  submitLogout() {
    const wsfFormLogout: HTMLFormElement = document.getElementById('wsfLogout') as HTMLFormElement;
    wsfFormLogout.submit();
  }
  getUserProfile(): IUserProfile {
    return this.profile;
  }
}
